import vueCustomerSvc from '../../services/vueCustomerSvc';

import Welcome from './Welcome';
const Orders = () =>  import(/* webpackChunkName: "rcd-group-purchases" */ './Purchases/Orders');
const OrderDetails = () =>  import(/* webpackChunkName: "rcd-group-purchases" */ './Purchases/OrderDetails');
const InactiveSubscriptions = () =>  import(/* webpackChunkName: "rcd-inactivesubs" */ './Purchases/InactiveSubscriptions');
const EditAutoDelivery = () =>  import(/* webpackChunkName: "rcd-group-editsub" */ './Purchases/EditAutoDelivery');
const EditAutoDeliveryDashboard = () =>  import(/* webpackChunkName: "rcd-group-editsub" */ './Purchases/EditAutoDelivery/EditAutoDeliveryDashboard');
const EditAutoDeliveryCancelReasons = () =>  import(/* webpackChunkName: "rcd-group-cancelflow" */ './Purchases/EditAutoDelivery/EditAutoDeliveryCancelReasons/EditAutoDeliveryCancelReasons');
const EditAutoDeliveryCancelColorIssue = () =>  import(/* webpackChunkName: "rcd-group-cancelflow" */ './Purchases/EditAutoDelivery/EditAutoDeliveryCancelColorIssue');
const EditAutoDeliveryCancel = () =>  import(/* webpackChunkName: "rcd-group-cancelflow" */ './Purchases/EditAutoDelivery/EditAutoDeliveryCancel');
const EditAutoDeliveryCancelTooMuch = () =>  import(/* webpackChunkName: "rcd-group-cancelflow" */ './Purchases/EditAutoDelivery/EditAutoDeliveryCancelTooMuch');
const Purchases = () =>  import(/* webpackChunkName: "rcd-group-purchases" */ './Purchases');
const Account = () =>  import(/* webpackChunkName: "rcd-account" */ './Account');
const Shop = () =>  import(/* webpackChunkName: "rcd-shop" */ './Shop');
const HowTo = () =>  import(/* webpackChunkName: "rcd-howto" */ './HowTo');
const CustomInstructions = () =>  import(/* webpackChunkName: "rcd-instructions" */ './HowTo/CustomInstructions');

function requireHardLogin(to, from, next) {
  vueCustomerSvc.isSoftLoggedIn().then(res => {
    if (res.data.softLogin) {
      window.location = '/signIn#?next=' + encodeURIComponent(to.path);
      return next(false);
    }
    next();
  }).catch(() => {
    window.location = '/signIn#?next=' + encodeURIComponent(to.path);
    return next(false);
  });
}

export default [
  { path: '/dashboard/welcome', component: Welcome, alias: '/dashboard/welcome/recommendations' },
  { path: '/dashboard/wecome', component: Welcome, alias: '/dashboard/welcome/nextShipment' },
  { path: '/dashboard/purchases/orders', component: Orders, beforeEnter: requireHardLogin },
  { path: '/dashboard/purchases/order-details/:orderId', component: OrderDetails, props: true, beforeEnter: requireHardLogin },
  { path: '/dashboard/purchases/inactive-auto-delivery', component: InactiveSubscriptions },
  { path: '/dashboard/purchases/edit-auto-delivery/:subId', component: EditAutoDelivery,
    meta: {
      title: 'Manage Subscription'
    },
    children: [
      {
        path: '', name: 'subDashboard',
        component: EditAutoDeliveryDashboard
      },
      {
        path: 'cancel',
        name: 'cancel',
        component: EditAutoDeliveryCancel,
        beforeEnter: requireHardLogin,
        meta: {
          title: 'Cancel Subscription'
        }
      },
      {
        path: 'cancel-reasons',
        name: 'cancelReasons',
        component: EditAutoDeliveryCancelReasons,
        beforeEnter: requireHardLogin,
        meta: {
          title: 'Cancel Subscription - Reasons'
        }
      },
      {
        path: 'cancel-color-issue',
        name: 'cancelColorIssue',
        component: EditAutoDeliveryCancelColorIssue,
        beforeEnter: requireHardLogin,
        meta: {
          title: 'Cancel Subscription - Color Issue'
        }
      },
      {
        path: 'cancel-too-much',
        name: 'cancelTooMuch',
        component: EditAutoDeliveryCancelTooMuch,
        beforeEnter: requireHardLogin,
        meta: {
          title: 'Cancel Subscription - Too Much Color'
        }
      },
    ],
  },
  // { path: '/dashboard/purchases/edit-auto-delivery/:subId/cancel-reasons', component: EditAutoDelivery },
  { path: '/dashboard/purchases', component: Purchases, beforeEnter: requireHardLogin },

  { path: '/dashboard/account', component: Account, beforeEnter: requireHardLogin },
  { path: '/dashboard/account/edit-password', component: Account, beforeEnter: requireHardLogin },
  { path: '/dashboard/account/edit-payment', component: Account, beforeEnter: requireHardLogin },
  { path: '/dashboard/account/edit-address', component: Account, beforeEnter: requireHardLogin },
  { path: '/dashboard/shop', component: Shop },

  { path: '/dashboard/how-to/custom-instructions', component: CustomInstructions },
  { path: '/dashboard/how-to', component: HowTo },

  //- default fallback
  { path: "/dashboard*", redirect: '/dashboard/welcome' }
];
